/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCloudOff = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m1.707.293 22 22-1.414 1.414-3.79-3.788c-.193.036-6.028.063-17.503.081v-1.067c0-2.646 1.319-5.061 3.411-6.343.04-1.868.964-3.502 2.334-4.43L.293 1.706zm6.545 9.373c-1.08.493-1.842 1.683-1.842 3.067 0 .134.006.267.021.396l.086.8-.674.325C4.421 14.942 3.414 16.35 3.102 18h13.483zM14.796 4c2.718 0 4.951 2.14 5.333 4.982C21.869 9.986 23 11.984 23 14.152a6.154 6.154 0 0 1-1.018 3.417l-1.448-1.448c.296-.564.466-1.22.466-1.92 0-1.565-.877-2.99-2.181-3.55l-.614-.262-.02-.72C18.125 7.613 16.637 6 14.796 6c-1.125 0-2.15.623-2.772 1.61l-1.428-1.428c1-1.346 2.531-2.182 4.2-2.182z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCloudOff as CloudOff };
